import { forwardRef, type Ref, type SVGProps } from "react";
const IconTextAlignCenterOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M3 5h26a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2" />
    <path d="M6.79 11a1 1 0 1 0 0 2h18.42a1 1 0 0 0 0-2Z" />
    <path d="M29 19H3a1 1 0 0 0 0 2h26a1 1 0 0 0 0-2" />
    <path d="M22 27H10a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2" />
  </svg>
);
const ForwardRef = forwardRef(IconTextAlignCenterOutlineSVG);
ForwardRef.displayName = "IconTextAlignCenterOutline";
export { ForwardRef as IconTextAlignCenterOutline };
